export const newsFeed = [
  {
    id: "n1",
    topic: "hot",
    tag: "今日热瓜",
    title: "某热播综艺录制现场花絮流出，嘉宾互动细节被反复回看",
    excerpt: "三段不同机位的现场画面同时流出，弹幕集中在同一个互动瞬间，网友逐帧对比后讨论热度一路上升。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20dark%20editorial%20still%20of%20a%20spotlight%20stage%20with%20warm%20red%20neon%20glow%20and%20blurred%20crowd%20silhouettes%2C%20moody%20entertainment%20news%20cover%2C%20high%20contrast%2C%20film%20grain&width=480&height=360&seq=hl-news-01&orientation=landscape",
    time: "12 分钟前",
    heat: "9.8万",
    comments: 326,
  },
  {
    id: "n2",
    topic: "star",
    tag: "明星动态",
    title: "新剧开机路透曝光，剧组成员当日状态引发集中讨论",
    excerpt: "开机仪式结束后的路透照在小范围流传，由于取景地与官宣信息有出入，围绕剧组的猜测随之升温。",
    cover: "https://readdy.ai/api/search-image?query=Backstage%20corridor%20with%20warm%20lamp%20light%20and%20camera%20equipment%20on%20a%20wooden%20floor%2C%20moody%20cinematic%20editorial%20photography%2C%20soft%20shadows&width=480&height=360&seq=hl-news-02&orientation=landscape",
    time: "28 分钟前",
    heat: "7.2万",
    comments: 214,
  },
  {
    id: "n3",
    topic: "variety",
    tag: "综艺现场",
    title: "音乐节后台画面流出，彩排顺序临时调整被观众察觉",
    excerpt: "现场观众发现演出顺序与节目单不一致，随后有后台视频补充说明，话题讨论转向节目编排本身。",
    cover: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20golden%20vintage%20microphone%20on%20a%20dark%20stage%20with%20warm%20haze%20and%20soft%20bokeh%20lights%2C%20cinematic%20moody%20editorial&width=480&height=360&seq=hl-news-03&orientation=landscape",
    time: "46 分钟前",
    heat: "5.6万",
    comments: 158,
  },
  {
    id: "n4",
    topic: "star",
    tag: "明星动态",
    title: "红毯造型合集：本季最受关注的几套造型逐一出图",
    excerpt: "造型师与品牌方的合作细节被镜头记录，几套高讨论度造型的返图在短时间内被大量转发。",
    cover: "https://readdy.ai/api/search-image?query=Red%20carpet%20walkway%20with%20warm%20spotlights%20and%20velvet%20rope%20at%20night%2C%20moody%20editorial%20fashion%20photography%2C%20cinematic%20depth&width=480&height=360&seq=hl-news-04&orientation=landscape",
    time: "1 小时前",
    heat: "6.4万",
    comments: 197,
  },
  {
    id: "n5",
    topic: "film",
    tag: "影视幕后",
    title: "某剧组深夜收工被拍，主创同行画面引来新一轮猜测",
    excerpt: "收工现场的照片在凌晨流出，由于拍摄地与剧组官宣行程接近，关于项目进度的讨论持续升温。",
    cover: "https://readdy.ai/api/search-image?query=Film%20set%20with%20a%20clapperboard%20and%20warm%20studio%20lights%20on%20a%20dark%20background%2C%20cinematic%20moody%20editorial%20still&width=480&height=360&seq=hl-news-05&orientation=landscape",
    time: "2 小时前",
    heat: "4.9万",
    comments: 143,
  },
  {
    id: "n6",
    topic: "circle",
    tag: "圈内爆料",
    title: "代言合约变动传闻登上热搜，双方暂未公开回应",
    excerpt: "多个来源提到合作节奏发生变化，但目前没有官方口径，相关讨论仍停留在传闻与推测层面。",
    cover: "https://readdy.ai/api/search-image?query=Stack%20of%20newspapers%20under%20a%20warm%20desk%20lamp%20in%20a%20dim%20office%2C%20moody%20editorial%20photography%2C%20close%20up%20texture&width=480&height=360&seq=hl-news-06&orientation=landscape",
    time: "3 小时前",
    heat: "8.1万",
    comments: 268,
  },
  {
    id: "n7",
    topic: "variety",
    tag: "综艺现场",
    title: "综艺正片与预告剪辑差异被逐帧对比，剪辑版本成焦点",
    excerpt: "有网友整理出预告与正片的分镜差异，讨论点从嘉宾互动转移到后期剪辑思路，话题持续发酵。",
    cover: "https://readdy.ai/api/search-image?query=Television%20variety%20show%20stage%20with%20warm%20colored%20lights%20and%20empty%20audience%20seats%2C%20cinematic%20moody%20editorial&width=480&height=360&seq=hl-news-07&orientation=landscape",
    time: "4 小时前",
    heat: "5.2万",
    comments: 129,
  },
  {
    id: "n8",
    topic: "film",
    tag: "影视幕后",
    title: "影视基地探班：多组剧组同日赶工，场地排期被拍到",
    excerpt: "同一基地内多组剧组同时开工，场地排期表的一角被镜头带到，外界借此推测各项目的上线节奏。",
    cover: "https://readdy.ai/api/search-image?query=Control%20room%20wall%20of%20monitors%20glowing%20warm%20orange%20in%20a%20dark%20production%20studio%2C%20cinematic%20moody%20editorial&width=480&height=360&seq=hl-news-08&orientation=landscape",
    time: "5 小时前",
    heat: "3.7万",
    comments: 96,
  },
  {
    id: "n9",
    topic: "circle",
    tag: "圈内爆料",
    title: "社交平台动态被秒删，截图已在多个话题下流传",
    excerpt: "一条发布后迅速消失的动态引发关注，截图在讨论区扩散，目前缺少可核实的完整上下文。",
    cover: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20with%20blurred%20chat%20bubbles%20and%20warm%20bokeh%20in%20a%20dark%20room%2C%20moody%20close%20up%20cinematic&width=480&height=360&seq=hl-news-09&orientation=landscape",
    time: "6 小时前",
    heat: "6.9万",
    comments: 231,
  },
  {
    id: "n10",
    topic: "review",
    tag: "网友复盘",
    title: "年度榜单提前泄露，名次顺序在网上引发新一轮争议",
    excerpt: "疑似榜单截图在小范围流传，由于与往届规律差异明显，网友开始整理数据来源并逐项复盘。",
    cover: "https://readdy.ai/api/search-image?query=Golden%20trophy%20award%20on%20a%20dark%20reflective%20surface%20with%20warm%20rim%20light%20and%20soft%20smoke%2C%20cinematic%20editorial&width=480&height=360&seq=hl-news-10&orientation=landscape",
    time: "8 小时前",
    heat: "4.3万",
    comments: 118,
  },
];